import { textToneClass, type StatusTone } from '../../design'
import { REPLY_COPY } from './copy'
import type { ReplyLength } from './limits'

const counterTone = (length: ReplyLength): StatusTone | null => {
  if (length.overLimit) return 'danger'
  if (length.nearLimit) return 'warning'
  return null
}

const counterText = (length: ReplyLength): string =>
  length.nearLimit
    ? REPLY_COPY.characterCountWithLimit(length.count, length.limit, length.unit)
    : REPLY_COPY.characterCount(length.count, length.unit)

export const ReplyLengthMeter = ({ length }: { length: ReplyLength }) => {
  const tone = counterTone(length)
  return (
    <>
      <p className="composer-meta">
        <span className={tone === null ? 'num' : `num ${textToneClass(tone)}`}>{counterText(length)}</span>
      </p>
      {length.overLimit ? (
        <p className="composer-hint tone-danger" role="status">
          {REPLY_COPY.overLimit(-length.remaining, length.unit)}
        </p>
      ) : null}
    </>
  )
}
